import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  detailedIssueForCentralizedView: {},
  centralizedIssuesListLoading: false,
  dashboardIssuesListLoading: false,
  projectIssuesListLoading: false,
  centralizedIssues: [],
  centralizedIssuesForDashboard: [],
  centralizedIssuesForProjectDetails: [],
  centralizedIssuesListOptions: {
    issueTypes: [],
    sort: {
      priorityScore: 'desc',
    },
    page: 1,
    limit: 20,
    search: '',
    toggles: {
      hideSuppress: true,
      onlyCVEs: false,
      hideFixed: true,
      specificSearch: false,
    },
  },
  openDetailedIssuePopupOnStart: false,
  centralizedIssuesListForProject: [],
  issuesRefId: '',
  issuesRunningInterval: false,
  issuesProgress: 0,
  dashboardIssuesRefId: '',
  dashboardIssuesProgress: 0,
  dashboardIssuesRunningInterval: false,
  projectIssuesRefId: '',
  projectIssuesProgress: 0,
  projectIssuesRunningInterval: false,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
